import { ModelBase } from 'store/model-base';

export class CmsLineDataPlanCollection extends ModelBase {
    public static storeName: string = 'cmsLineDataPlanCollection';
    public plans: CmsDataPlanDetails[];
}
